// Kevin R (2023-10-12)
// Decided to keep the short vs long code in the code base as I can see future experiments
// might want to try different variations of the long version. So instead of deleting the code
// im just adding a hard coded flag which forces everyone to use the short version
export const ACTIVE_SIGNUP_VARIATION = 'short'
